import CreateChannelHeader from './CreateChannelHeader'

export default CreateChannelHeader
